
import { loadLayerByWorkspaceId } from '../../api/layerApi'
class Mapviewer extends gt3d.gt_mapview {
    destroy() {
        console.log(' mapview destroy ')
        super.destroy()
    }

    async create(wid) {
        let viewer = super.create()

        let provider = new Cesium.UrlTemplateImageryProvider({
            url: 'https://webst02.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}'
        })

        let d = this.dStore.ImageLayers.add('高德地图', provider)
        d.setdispcondition(0, gt3d.gtBaseType.DISABLE_DEPTH_DISTANCE)
        d.show = true
        await this.loadLayers(wid)

        gt3d.gt_utils.flyTo(viewer, { 'y': 27.326358, 'x': 120.368668, 'z': 108001.019640, 'heading': 0, 'pitch': -90, 'roll': 0 })
        console.log(' mapview create ', this)
    }

    async loadLayers(wid) {
        await loadLayerByWorkspaceId({ id: wid }).then(res => {
            res.data.data.forEach(item => {
                if (item.type == 'OGC') {
                    var provider = new Cesium.UrlTemplateImageryProvider({
                        url: item.url,
                        layer: item.layer,
                        style: item.style,
                        format: item.format,
                        tileMatrixSetID: item.tileMatrixSetID,
                        minimumLevel: 0,
                        maximumLevel: 20,
                        rectangle: item.rectangle ? Cesium.Rectangle.fromDegrees(item.rectangle[0], item.rectangle[1], item.rectangle[2], item.rectangle[3]) : null,
                        tilingScheme: item.isMercator ? null : new Cesium.GeographicTilingScheme()
                    })
                    let d = this.dStore.ImageLayers.add(item.alias, provider)
                    d.setdispcondition(0, gt3d.gtBaseType.DISABLE_DEPTH_DISTANCE)
                    d.show = true
                } else if (item.type == 'REST') {
                    if (item.restType == '3Dtiles') {
                        let tilesProvider = new Cesium.Cesium3DTileset({
                            url: item.url,
                            opacity: 1,
                            maximumScreenSpaceError: 16,
                            dynamicScreenSpaceError: true,
                            dynamicScreenSpaceErrorDensity: 0.00278,
                            dynamicScreenSpaceErrorFactor: 4.0,
                            dynamicScreenSpaceErrorFactorHeightFalloff: 0.25,
                            maximumMemoryUsage: 1024,
                            skipLevelOfDetail: true,
                            immediatelyLoadDesiredLevelOfDetail: true,
                            flyTo: false
                        })
                        let d = this.dStore.Primitives.add(item.alias, tilesProvider)
                        d.setdispcondition(0, 5000)
                        d.show = true
                    } else if (item.restType == 'ImageSlices') {
                        var imageSlicesProvider = new Cesium.UrlTemplateImageryProvider({
                            url: item.url,
                            layer: item.layer,
                            style: item.style,
                            format: item.format,
                            tileMatrixSetID: item.tileMatrixSetID,
                            minimumLevel: 0,
                            maximumLevel: 20,
                            rectangle: item.rectangle ? Cesium.Rectangle.fromDegrees(item.rectangle[0], item.rectangle[1], item.rectangle[2], item.rectangle[3]) : null,
                            tilingScheme: item.isMercator ? null : new Cesium.GeographicTilingScheme()
                        })
                        let d = this.dStore.ImageLayers.add(item.alias, imageSlicesProvider)
                        d.setdispcondition(0, gt3d.gtBaseType.DISABLE_DEPTH_DISTANCE)
                        d.show = true
                    } else if (item.restType == 'DEM') {
                        var terrainProvider = new Cesium.CesiumTerrainProvider({
                            url: item.url
                        })
                        terrainProvider.show = item.show
                        let d = this.dStore.Terrains.add(item.alias, terrainProvider)
                        this.dStore.Terrains.default(0)
                    }
                }
            })
        })
    }
}

export { Mapviewer }
